// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3wKWs","error":"Textarea_error__3BT0t","readonly":"Textarea_readonly__1lyhB","disabled":"Textarea_disabled__1XdMM"};